// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wp-block-image img{max-width:100%;margin-bottom:30px}.aligncenter{display:flex;justify-content:center}.bloggImage{width:100%;height:auto}li{margin-bottom:.5em}.nowrap{white-space:nowrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
